import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const WorkQualityToWeightWaistManagement = {
  label: "工作性質 vs 體重及腰圍管理",
  key: "WorkQualityToWeightWaistManagement",
  path: "BMI/WorkQualityToWeightWaistManagement",
  api: "TCS_V_BMIHEBMIV",
  render: (options) => (
    <Diagram.BMI.WorkQualityToWeightWaistManagement {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "工作性質",
      field: "工作性質",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
